module.exports = __webpack_public_path__ + "img/175.5f1903d5.png";